export const pluralize = (count: number, singular: string, plural: string) =>
  count === 1 ? singular : plural;

export const generateShortId = (length: number = 8) => {
  return Math.random()
    .toString(36)
    .substring(2, Math.max(0, length) + 2);
};

export const toTitleCase = (str: string) => {
  return str.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};

export const isNumericString = (value: string): boolean => {
  return !isNaN(Number(value)) && value.trim() !== '' && !value.endsWith('.');
};
